import { AdminService } from '../../../services/admin.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { CountryModel } from 'src/app/models/country.model';
import { UntypedFormControl } from '@angular/forms';
import { Icons } from '../../../models/icons.model';
import { map, startWith, concatAll } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { UserModel } from 'src/app/models/user.model';
import parsePhoneNumber, { PhoneNumber, CountryCode, getCountries } from 'libphonenumber-js'

@Component({
  selector: 'app-admin-user',
  standalone: false,
  templateUrl: './admin-user.component.html',
  styleUrls: ['./admin-user.component.scss'],
})
export class AdminUserComponent implements OnInit, OnDestroy {
  // Event Handlers
  private adminLoadedEventHandler: Subscription;

  // Variables
  countries: CountryModel[] = [];
  filter = new UntypedFormControl('');
  filteredUsers: Observable<UserModel[]>;
  icons = new Icons();
  phoneCodeMap: Map<number, string> = new Map();
  phoneMaskMap: Map<number, string> = new Map();

  constructor(public adminService: AdminService) { }

  ngOnInit(): void {
    if (!this.adminService.isReady) {
      this.adminLoadedEventHandler = this.adminService.adminServiceLoadedEvent.subscribe(
        () => {
          this.initSearch();
        }
      );
    } else {
      this.initSearch();
    }
  }
  ngOnDestroy() {
    if (this.adminLoadedEventHandler)
      this.adminLoadedEventHandler.unsubscribe();
  }

  /**
   * Fetch all countries
   * @returns void
   */
  fetchCountries(): void {
    // Gets the all countries
    this.countries = JSON.parse(JSON.stringify(this.adminService.countries));

    // Map phone mask and phone codes
    this.countries.forEach((country: CountryModel) => {
      this.phoneMaskMap.set(country.Id, country.PhoneMask);
      this.phoneCodeMap.set(country.Id, "+" + country.PhoneCode);
    })
  }

  /**
   * Initialize the search users
   * @returns void
   */
  private initSearch(): void {
    // Fetch the countries
    this.fetchCountries();

    // Initialize the search users
    this.filteredUsers = this.filter.valueChanges.pipe(
      startWith(''),
      map((text) => this.searchUsers(text))
    );
  }

  /**
   * Clear Search
   * @returns void
   */
  clearSearch(): void {
    this.filter.setValue('');
  }

  /**
   * Search Users
   * @param  {string} text - Text search
   * @returns UserModel
   */
  private searchUsers(text: string): UserModel[] {
    return this.adminService.usersWithCountry?.filter((user) => {
      const term = text.toLowerCase();
      return (
        user.Name?.toLowerCase().includes(term) ||
        user.EmailAddress?.toLowerCase().includes(term) ||
        user.Upn?.toLowerCase().includes(term) ||
        user.Mobile?.toLocaleLowerCase().includes(term)
      );
    });
  }

  formatUserMobile(user: UserModel): string {
    const formattedNumber = parsePhoneNumber(user.Mobile || '', user.Country.Code as CountryCode);
    return formattedNumber ? formattedNumber.formatInternational() : user.Mobile || '';
  }

}
